import React from "react";


export default function Plural({value}) {
 if(value === 1) return(<></>)
return(<>s</>)
}